module.exports = __webpack_public_path__ + "static/media/cover.c9baaee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/cover.jpg
// module id = 1432
// module chunks = 0